// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import {
    createElement,
    Component,
    PropTypes,
    Translate,
    Dialog,
    Button,
    Media,
    MediaSection,
    Icon,
} from '@plesk/ui-library';

class RestartServer extends Component {
    state = {
        isDialogOpen: false,
        dialogState: null,
    };

    handleShowDialog = () => {
        this.setState({
            isDialogOpen: true,
        });
    };

    handleCloseDialog = () => {
        if (this.state.dialogState) {
            return;
        }

        this.setState({
            isDialogOpen: false,
        });
    };

    handleSubmit = () => {
        const { onRestartServer } = this.props;
        const handleRestart = isRedirectStarted => {
            if (isRedirectStarted !== true) {
                this.setState({
                    dialogState: null,
                    isDialogOpen: false,
                });
            }
        };

        this.setState({
            dialogState: 'submit',
        });

        onRestartServer()
            .then(handleRestart)
            .catch(handleRestart);
    };

    render() {
        const { isDialogOpen, dialogState, ...props } = this.state;

        return (
            <Media image={<Icon src="images/restart.png" size="md" alt="Restart Server" />} {...props}>
                <MediaSection>
                    <Translate content="RestartServer.description" />
                </MediaSection>
                <MediaSection>
                    <Button onClick={this.handleShowDialog}>
                        <Translate content="RestartServer.button" />
                    </Button>
                </MediaSection>
                <Dialog
                    isOpen={isDialogOpen}
                    onClose={this.handleCloseDialog}
                    size="sm"
                    image={<Icon src="images/restart-server-dialog.png" size="xxl" />}
                    form={{
                        onSubmit: this.handleSubmit,
                        state: dialogState,
                        submitButton: {
                            id: 'server-restart',
                            intent: 'danger',
                            children: <Translate content="RestartServer.button" />,
                        },
                        hideRequiredLegend: true,
                    }}
                >
                    <Translate content="RestartServer.dialogText" />
                </Dialog>
            </Media>
        );
    }
}

RestartServer.propTypes = {
    onRestartServer: PropTypes.func.isRequired,
};

export default RestartServer;



// WEBPACK FOOTER //
// ./app/repair/Overview/RestartServer.js